"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(arr) {
  return {}.toString.call(arr) === '[object Array]';
};

exports.default = _default;
//# sourceMappingURL=isArray.js.map